function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
const useInView = (elementsIds, viewportPositionTopTrigger = '50%', viewportPositionBottomTrigger = '50%', outwardTrigger = false) => {
  const _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    inView = _useState2[0],
    setInView = _useState2[1];
  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined' || !elementsIds) {
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const anchorsEnteringView = entries.filter(entry => entry.isIntersecting).map(entry => elementsIds.indexOf(entry.target.id));
      if (anchorsEnteringView.length > 0) {
        const index = anchorsEnteringView[0];
        setInView(index);
      } else {
        const entry = entries[0];
        const rootY = entry?.rootBounds?.y || 0;
        if (entry && entry.boundingClientRect.y > rootY) {
          setInView(index => index === 0 ? -1 : index);
        }
      }
    }, {
      threshold: 0,
      rootMargin: `${!outwardTrigger ? '-' : ''}${typeof viewportPositionTopTrigger === 'number' ? `${viewportPositionTopTrigger}px` : viewportPositionTopTrigger} 0px ${!outwardTrigger ? '-' : ''}${typeof viewportPositionBottomTrigger === 'number' ? `${viewportPositionBottomTrigger}px` : viewportPositionBottomTrigger} 0px`
    });
    elementsIds.forEach(anchor => {
      const els = document.querySelectorAll(`#${anchor}`);
      els?.forEach(el => {
        if (el) observer.observe(el);
      });
    });
    return () => observer.disconnect();
  }, [elementsIds, viewportPositionTopTrigger, viewportPositionBottomTrigger, outwardTrigger]);
  return inView;
};
export { useInView };
//# sourceMappingURL=useInView.js.map
